import React, { useContext, useState } from 'react';
import firebase from 'firebase/compat/app';
import 'firebase/auth';

import WallBoardSetUp from './WallBoardSetUp';
import CloudFunctionClientContext from '../../contexts/CloudFunctionClientContext';
import { ACCESS_CODE_LENGTH } from './normalizeAccessCode';

const WallBoardSetUpContainer = () => {
  const { api } = useContext(CloudFunctionClientContext);
  const [accessCode, setAccessCode] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // From AccessCodeInput: already in capitals, at most 5 characters
  const logIn = ({ code }: { code: string }) => {
    if (isLoading || code.length !== ACCESS_CODE_LENGTH) {
      return;
    }
    setIsLoading(true);
    api.post(`/v1/auth/token`, { token: code }).then((response) => {
      if (response.ok) {
        setIsLoading(false);
        // @ts-ignore
        const { customToken } = response.data;
        firebase
          .auth()
          .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
          .then(() => {
            return firebase.auth().signInWithCustomToken(customToken as string);
          })
          .then(() => {
            setIsLoading(false);
          });
      } else {
        setIsLoading(false);
        alert('Setup Failed. Has your code expired or already been used?');
      }
    });
  };

  return (
    <WallBoardSetUp
      accessCode={accessCode}
      onAccessCodeChange={setAccessCode}
      onCodeComplete={(code) => logIn({ code })}
      onLogInClicked={() => logIn({ code: accessCode })}
      isComplete={accessCode.length === ACCESS_CODE_LENGTH}
      isLoading={isLoading}
    />
  );
};

export default WallBoardSetUpContainer;
